import styled from "styled-components";

const StyledForBackgroundImage = styled.div<{ image: string }>`
 .bg-image {
        background-image: url(${props => props.image});
        background-repeat : no-repeat;
       background-position : center;
    }
`
export const OverlayContact = styled.div`
  position: absolute;
  top: 80px;
  left: 0;
  z-index:1;
  width: 100%;
  height:226px;
  background-color: rgba(0, 0, 0, 0.6); 
  @media only screen and (max-width : 1024px){
        height: 226px;
   }
`;

export default StyledForBackgroundImage